import { EditActionDefinition } from '@wix/editor-platform-host-integration-apis';
import { PlatformContext } from './types';
import { ActionContext } from './ActionContext';
import { CustomActionBuilder, CustomActionSource } from './customActions';
import { NativeActionBuilder, NativeActionSource } from './nativeActions';
import { EditActionsFactory } from './EditActionsFactory';
import { SystemActionBuilder } from './systemActions/SystemActionBuilder';
import { SystemActionSource } from './systemActions/SystemActionSource';

export class EditActionsAPI {
  constructor(private readonly ctx: PlatformContext) {}

  getEditActions(): {
    nativeActions: EditActionDefinition[];
    customActions: EditActionDefinition[];
    systemActions: EditActionDefinition[];
  } {
    const actionContext = new ActionContext(this.ctx);
    const tags = this.ctx?.actionMetadata?.tags;
    return {
      nativeActions: new EditActionsFactory(
        new NativeActionSource(this.ctx),
        new NativeActionBuilder(actionContext),
        tags,
      ).create(),
      customActions: new EditActionsFactory(
        new CustomActionSource(this.ctx),
        new CustomActionBuilder(actionContext),
        tags,
      ).create(),
      systemActions: new EditActionsFactory(
        new SystemActionSource(this.ctx),
        new SystemActionBuilder(actionContext),
        tags,
      ).create(),
    };
  }
}
